"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from "../../styles/clsx.js";
import classes from "./Hr.module.css.js";
const Hr = forwardRef(
  ({
    className,
    as: Element = "hr",
    "aria-hidden": ariaHidden = "true",
    ...props
  }, ref) => /* @__PURE__ */ jsx(
    Element,
    {
      ...props,
      ref,
      className: clsx(classes.base, className),
      "aria-hidden": ariaHidden
    }
  )
);
Hr.displayName = "Hr";
export {
  Hr
};
